import { render, staticRenderFns } from "./LicencaEspecial.vue?vue&type=template&id=0134bbca"
import script from "./LicencaEspecial.vue?vue&type=script&lang=js"
export * from "./LicencaEspecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports